export default __webpack_public_path__ + "static/Corprate_WhoWeAre_aboutus_01-728e75bccfb5bf6e50ee3eea19ba0fad.jpg";